"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_TEXT_SIZES = exports.BUTTON_SIZES = exports.BUTTON_VARIANTS = void 0;

var _Theme = require("../../Theme");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/** Available color themes */
var BUTTON_VARIANTS = {
  primaryBlack: _defineProperty({
    backgroundColor: "black100",
    borderColor: "black100",
    color: "white100"
  }, "@media ".concat(_Theme.themeProps.mediaQueries.hover), {
    "&:hover": {
      backgroundColor: "purple100",
      borderColor: "purple100",
      color: "white100"
    }
  }),
  primaryWhite: _defineProperty({
    backgroundColor: "white100",
    borderColor: "white100",
    color: "black100"
  }, "@media ".concat(_Theme.themeProps.mediaQueries.hover), {
    "&:hover": {
      backgroundColor: "purple100",
      borderColor: "purple100",
      color: "white100"
    }
  }),
  secondaryGray: _defineProperty({
    backgroundColor: "black10",
    borderColor: "black10",
    color: "black100"
  }, "@media ".concat(_Theme.themeProps.mediaQueries.hover), {
    "&:hover": {
      backgroundColor: "black30",
      borderColor: "black30",
      color: "black100"
    }
  }),
  secondaryOutline: _defineProperty({
    backgroundColor: "white100",
    borderColor: "black10",
    color: "black100"
  }, "@media ".concat(_Theme.themeProps.mediaQueries.hover), {
    "&:hover": {
      backgroundColor: "white100",
      borderColor: "black100",
      color: "black100"
    }
  }),
  noOutline: {
    backgroundColor: "transparent",
    borderColor: "transparent",
    color: "black100"
  }
};
/** Name of color theme */

exports.BUTTON_VARIANTS = BUTTON_VARIANTS;

/** Styles associated with available sizes */
var BUTTON_SIZES = {
  block: {
    small: {
      height: "26px",
      px: 1.5
    },
    medium: {
      height: "41px",
      px: 2
    },
    large: {
      height: "50px",
      px: 3
    }
  },
  inline: {
    small: {
      height: "17px",
      px: 0
    },
    medium: {
      height: "21px",
      px: 0
    },
    large: {
      height: "21px",
      px: 0
    }
  }
};
/** Text sizes associated with available button sizes */

exports.BUTTON_SIZES = BUTTON_SIZES;
var BUTTON_TEXT_SIZES = {
  small: "2",
  medium: "3t",
  large: "3t"
};
exports.BUTTON_TEXT_SIZES = BUTTON_TEXT_SIZES;
//# sourceMappingURL=tokens.js.map